import { useState } from 'react';

export const useDebounce = () => {
  const [intervalId, setIntervalId] = useState<number | null>(null);
  return (func: any, wait: number) => {
    if (intervalId) clearTimeout(intervalId);
    setIntervalId(window.setTimeout(func, wait));
  };
};
